module.exports = __webpack_public_path__ + "img/thumbnail_AmurLeopard_j_normal.63c4b068.png";